import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import * as Dialog from "@radix-ui/react-dialog";
import Logo from "./Logo";
import { ActionLink } from "./Editorial";

const LINKS = [["/", "Home"], ["/about", "About Us"], ["/clients", "Our Clients"], ["/contact", "Contact Us"]];
const slug = (label) => label.toLowerCase().replaceAll(" ", "-");

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    useEffect(() => setOpen(false), [location]);
    return (
        <header className="site-header" data-testid="navbar">
            <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to content</a>
            <div className="container nav-inner">
                <Link to="/" data-testid="nav-logo" aria-label="Decorcrafts home"><Logo testId="nav-wordmark" /></Link>
                <nav className="desktop-nav" aria-label="Primary">
                    {LINKS.map(([to, label]) => <NavLink key={to} to={to} end data-testid={`nav-link-${slug(label)}`} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>{label}</NavLink>)}
                    <ActionLink to="/contact" testId="nav-cta-button">Get in Touch</ActionLink>
                </nav>
                <Dialog.Root open={open} onOpenChange={setOpen}>
                    <Dialog.Trigger className="mobile-toggle icon-button" data-testid="nav-menu-toggle" aria-label="Open navigation"><Menu size={24} /></Dialog.Trigger>
                    <Dialog.Portal>
                        <Dialog.Overlay className="menu-overlay" data-testid="mobile-menu-overlay" />
                        <Dialog.Content className="mobile-menu" aria-describedby={undefined} data-testid="mobile-menu">
                            <Dialog.Title className="sr-only">Navigation</Dialog.Title>
                            <div className="mobile-menu-top"><Link to="/" onClick={() => setOpen(false)} aria-label="Decorcrafts home" data-testid="mobile-menu-logo"><Logo testId="mobile-wordmark" /></Link><Dialog.Close className="icon-button" aria-label="Close navigation" data-testid="mobile-menu-close"><X size={24} /></Dialog.Close></div>
                            <nav aria-label="Mobile" className="mobile-nav">
                                {LINKS.map(([to, label], i) => <NavLink key={to} to={to} end onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${slug(label)}`}><span className="eyebrow">0{i + 1}</span>{label}</NavLink>)}
                            </nav>
                            <ActionLink to="/contact" testId="mobile-nav-cta">Get in Touch</ActionLink>
                        </Dialog.Content>
                    </Dialog.Portal>
                </Dialog.Root>
            </div>
        </header>
    );
}